import {twMerge} from 'tailwind-merge';

import PageHeader from '@/components_legacy/common/PageHeader';
import {BUMPY_GROUP} from '@/shared/consts/legal';
import {getLegalContent} from '@/shared/lib/legal/getLegalContent';
import {APP_ROUTES} from '@/utils_legacy/routes';
import Footer from '@/widgets/footer';

export default function Terms() {
  const content = getLegalContent(
    BUMPY_GROUP.address,
    BUMPY_GROUP.company,
    APP_ROUTES.PrivacyPolicyGroup
  );

  return (
    <div>
      <PageHeader
        goBack={() => ''}
        withoutButton
        title="Terms of Service"
        className="sticky top-0"
      />
      <div className="mt-10 flex flex-col gap-4 px-12 sm:px-20">
        <h2 className="font-bold text-xl">1. Glossary</h2>
        <div className="border border-stroke">
          {content.terms.map((data, index) => (
            <div
              key={data.definition}
              className={twMerge(
                'flex min-h-full w-full text-sm',
                index === 0
                  ? 'bg-light-primary font-bold'
                  : 'hover:bg-placeholder',
                index !== content.terms.length - 1 && 'border-stroke border-b'
              )}
            >
              <span className="w-[60%] py-1 pl-2 sm:w-[15%] sm:pl-4">
                {data.term}
              </span>
              <div className="!w-[1px] bg-stroke" />
              {data.link ? (
                <a
                  className="w-full py-1 pl-2 text-primary sm:pl-4"
                  href={data.link}
                >
                  {data.definition}
                </a>
              ) : (
                <span className="w-full py-1 pl-2 sm:pl-4">
                  {data.definition}
                </span>
              )}
            </div>
          ))}
        </div>
        <div className="my-4 ml-4">
          <span className="font-bold">IMPORTANT:</span>
          PLEASE READ THESE TERMS OF SERVICE ("TERMS") CAREFULLY BEFORE USING
          THE APP OR SITE AND ACCESSING THE DIGITAL PRODUCTS OFFERED BY OUR
          COMPANY. BY USING THE APP OR SITE AND ACCESSING THE DIGITAL PRODUCTS,
          YOU AGREE TO BE BOUND BY THESE TERMS .
        </div>
      </div>
      <ol className="flex flex-col gap-8 px-12 sm:px-20">
        {content.sections.map((section, index) => (
          <li key={index}>
            <h2 className="font-bold text-xl">{`${index + 2}. ${section.title}`}</h2>
            <ol className="list-disc pt-4 pl-8">
              {section.list.map((item, subIndex) => (
                <li key={subIndex}>{item}</li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
      <div className="boxShadow h-1 w-full" />
      <Footer hasShadow legal={BUMPY_GROUP} />
    </div>
  );
}
